import { memo, useMemo } from "react";
import { Hand } from "lucide-react";
import { STATUSES } from "@/lib/constants";
import { fmtINR } from "@/lib/format";
import { leadFlags } from "@/lib/leads";
import { LeakBadges } from "./LeakBadges";

const stop = (e) => e.stopPropagation();

export const LeadCard = memo(function LeadCard({ lead, setterName, closerName, today, onOpen, onMove, onTouch, dragging }) {
  const flags = useMemo(() => leadFlags(lead, today), [lead, today]);
  const moveOptions = useMemo(() => STATUSES.filter((s) => s !== lead.status), [lead.status]);
  const id = lead.id;
  return (
    <div data-testid={`lead-card-${id}`} onClick={() => onOpen(id)} className={`lead-card group ${dragging ? "lead-card-dragging" : ""}`}>
      <div className="flex items-start justify-between gap-2">
        <p data-testid={`lead-card-name-${id}`} className="font-display font-semibold text-[15px] leading-snug text-slate-50">{lead.name}</p>
        {lead.is_sample && <span className="sample-chip">Sample</span>}
      </div>
      <p data-testid={`lead-card-company-${id}`} className="text-[13px] text-slate-400 truncate">{lead.company || "No company"}</p>
      <div className="mt-2.5 grid grid-cols-2 gap-x-2 text-xs">
        <span className="text-slate-500">Setter</span><span className="text-slate-500">Closer</span>
        <span data-testid={`lead-card-setter-${id}`} className="truncate text-slate-200">{setterName || "—"}</span>
        <span data-testid={`lead-card-closer-${id}`} className="truncate text-slate-200">{closerName || "—"}</span>
      </div>
      <p data-testid={`lead-card-value-${id}`} className="mt-2 font-mono text-sm font-semibold text-slate-50">{fmtINR(lead.total_deal_value)}</p>
      {flags.length > 0 && <div className="mt-2"><LeakBadges flags={flags} prefix={`card-${id}`} /></div>}
      <div className="mt-3 flex items-center gap-1.5 border-t border-slate-800/70 pt-2.5" onClick={stop}>
        <select data-testid={`lead-card-move-select-${id}`} aria-label="Move to" value=""
          onChange={(e) => e.target.value && onMove(id, e.target.value)} className="move-select">
          <option value="" disabled>Move to…</option>
          {moveOptions.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        {lead.status !== "Won" && lead.status !== "Lost" && (
          <button type="button" data-testid={`lead-card-touch-btn-${id}`} onClick={() => onTouch(id)} className="touch-btn" title="Touched today">
            <Hand className="h-3.5 w-3.5" /> Touched
          </button>
        )}
      </div>
    </div>
  );
});
